import { Document, Page, View, StyleSheet, Text, Font } from "@react-pdf/renderer";
// import imgGaruda from '../../../assets/images/pngwing.png';
import srcArial from '../../../assets/custom/font/arial/arial.ttf'
import srcArialBold from '../../../assets/custom/font/arial/ARIBL0.ttf'
import Kelurahan from "../../../utilities/Kelurahan";
import Kecamatan from "../../../utilities/Kecamatan";
import KotaKab from "../../../utilities/KotaKab";
import Propinsi from "../../../utilities/Propinsi";

Font.register({ family: 'Arial', src: srcArial })
Font.register({ family: 'Arial-Bold', src: srcArialBold })

const styles = StyleSheet.create({
    page: {
        paddingTop: 20,
        paddingBottom: 48,
        paddingHorizontal: 42,
        boxSizing: "border-box"
    },
    headingImg: {
        width: 50,
        height: 50,
        marginVertical: 15,
        marginHorizontal: 235,
    },
    headingText: {
        fontSize: 12,
        textAlign: "center",
    },
    table: {
        display: "table",
        width: "auto"
    },
    tableRow: {
        flexDirection: "row",
        flexWrap: "wrap"
    },
    tableCol: {
        borderWidth: 0,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        padding: 1
    },
    text: {
        fontSize: 10,
        fontFamily: "Arial",
        textAlign: "justify"
    },
    textBold: {
        fontSize: 12,
        fontFamily: "Arial-Bold"
    }
})

const CetakLampTeknisCPPIB = ({ rowData, laporanFile, lampiranTeknis, dataOssHeader, dataProyek, dataProyekLokasi }) => {
    // console.log(dataOssHeader)
    // console.log(dataProyekLokasi)
    return (
        <Document>
            <Page size={'A4'} style={styles.page}>
                {/* <View>
                    <Image style={styles.headingImg} src={imgGaruda} />
                    <Text style={[styles.headingText, { fontFamily: 'Arial-Bold', marginBottom: 10, fontSize: 10 }]}>PEMERINTAH REPUBLIK INDONESIA</Text>
                </View>
                <View style={[{ marginBottom: 5 }]}>
                    <Text style={[styles.headingText, { fontFamily: 'Arial-Bold', fontSize: 10 }]}>PERIZINAN BERUSAHA UNTUK MENUNJANG KEGIATAN</Text>
                    <Text style={[styles.headingText, { fontFamily: 'Arial-Bold', fontSize: 10, textTransform: 'uppercase' }]}> USAHA SERTIFIKASI {(rowData.urIzin)}</Text>
                    <Text style={[styles.headingText, { fontFamily: 'Arial-Bold', marginBottom: 20, fontSize: 10 }]}> PB-UMKU:</Text>
                </View> */}
                <View style={[{ marginTop: 200, marginBottom: 20 }]}>
                    <View style={styles.table}>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableCol, { width: '33%', padding: 0.5 }]}>
                                <Text style={[styles.text, { fontSize: 10 }]}>Lampiran berikut memuat data teknis </Text>
                            </View>
                            <View style={[styles.tableCol, { width: '67%', padding: 0 }]}>
                                <Text style={[styles.text, { fontFamily: 'Arial-Bold', fontSize: 9 }]}>{rowData.namaIzin}</Text>
                            </View>
                        </View>
                    </View>
                </View>
                <View style={[{ marginBottom: 10 }]}>
                    <Text style={[styles.text, { fontSize: 10 }]}>Berdasarkan Peraturan Menteri Kelautan dan Perikanan Nomor 10 Tahun 2021 Tentang Standar Kegiatan Usaha dan Produk Pada Penyelenggaraan Perizinan Berusaha Berbasis Resiko sektor Kelautan dan Perikanan, menetapkan bahwa: </Text>
                </View>
                <View style={[styles.table, { marginBottom: 10 }]}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '2%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>1. </Text>
                        </View>
                        <View style={[styles.tableCol, { width: '40%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>Nomor Referensi Teknis </Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>: </Text>
                        </View>
                        <View style={[styles.tableCol, { width: '55%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>{lampiranTeknis.nomorReferensiTeknis}</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '2%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>2. </Text>
                        </View>
                        <View style={[styles.tableCol, { width: '40%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>Nama Pemilik/Perusahaan</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>: </Text>
                        </View>
                        <View style={[styles.tableCol, { width: '55%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>{rowData.namaPerseroan}</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '2%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>3. </Text>
                        </View>
                        <View style={[styles.tableCol, { width: '40%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>Nama Penanggungjawab Perusahaan</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>: </Text>
                        </View>
                        <View style={[styles.tableCol, { width: '55%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>{dataProyek.namaPj}</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '2%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>4. </Text>
                        </View>
                        <View style={[styles.tableCol, { width: '40%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>Alamat Pemilik/Perusahaan</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>: </Text>
                        </View>
                        <View style={[styles.tableCol, { width: '55%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>
                                {dataOssHeader.alamatPerseroan}, Desa/Kelurahan <Kelurahan id={dataOssHeader.perseroanDaerahId} />, 
                                Kec. <Kecamatan id={dataOssHeader.perseroanDaerahId.substring(0, 6)} />, 
                                &nbsp; <KotaKab id={dataOssHeader.perseroanDaerahId.substring(0, 4)} />, 
                                Provinsi <Propinsi id={dataOssHeader.perseroanDaerahId.substring(0, 2)} />, 
                                Kode Pos : {dataOssHeader.kodePosPerseroan}
                            </Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '2%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>5. </Text>
                        </View>
                        <View style={[styles.tableCol, { width: '40%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>Alamat Pabrik</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>: </Text>
                        </View>
                        <View style={[styles.tableCol, { width: '55%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>
                                {dataProyekLokasi.length > 0 && dataProyekLokasi[0].alamatUsaha}, 
                                Desa/Kelurahan {dataProyekLokasi.length > 0 && <Kelurahan id={dataProyekLokasi[0].proyekDaerahId} />},                                
                                Kec. {dataProyekLokasi.length > 0 && <Kecamatan id={dataProyekLokasi[0].proyekDaerahId.substring(0,6)} />},                                
                                &nbsp; {dataProyekLokasi.length > 0 && <KotaKab id={dataProyekLokasi[0].proyekDaerahId.substring(0,4)} />},                                
                                Provinsi {dataProyekLokasi.length > 0 && <Propinsi id={dataProyekLokasi[0].proyekDaerahId.substring(0,2)} />}                                
                            </Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '2%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>6. </Text>
                        </View>
                        <View style={[styles.tableCol, { width: '40%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>Peruntukan Produk</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>: </Text>
                        </View>
                        <View style={[styles.tableCol, { width: '55%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>{lampiranTeknis.peruntukanProduk}</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '2%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>7. </Text>
                        </View>
                        <View style={[styles.tableCol, { width: '40%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>Berlaku sampai dengan</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>: </Text>
                        </View>
                        <View style={[styles.tableCol, { width: '55%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>4 (empat) tahun sejak diterbitkan</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '2%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>8. </Text>
                        </View>
                        <View style={[styles.tableCol, { width: '40%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>Tingkat Pengawasan</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>: </Text>
                        </View>
                        <View style={[styles.tableCol, { width: '55%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>{laporanFile.totalHasil === 'P2' ? 'P2 (Pengawasan 2 kali dalam 4 tahun)' : laporanFile.totalHasil === 'P1' ? 'P1 (Pengawasan 1 kali dalam 4 tahun)' : laporanFile.totalHasil === 'P3' ? 'P3 (Pengawasan 3 kali dalam 4 tahun)' : ''}</Text>
                        </View>
                    </View>
                </View>
                <View style={[{ marginBottom: 10 }]}>
                    <Text style={[styles.text, { fontSize: 10 }]}>Pelaku usaha ini telah menerapkan dan memenuhi persyaratan {rowData.urIzin} sesuai dengan ketentuan peraturan perundang-undangan</Text>
                </View>
                <View>
                    <Text style={[styles.text, { fontSize: 10 }]}>Lampiran Perizinan Berusaha Untuk Menunjang Kegiatan Usaha ini memuat data teknis yang merupakan bagian tidak terpisahkan dari dokumen ini. Pelaku Usaha tersebut di atas wajib menjalankan kegiatan usahanya sesuai dengan ketentuan peraturan perundang-undangan yang berlaku.</Text>
                </View>
            </Page>
        </Document>
    )
}

export default CetakLampTeknisCPPIB